import { parseISO } from 'date-fns';
import type { OnboardingTourStepDataObject, OnboardingTourStepDataObjectOption } from '../service/login';

const supportedCustomSteps = {
  finish: undefined,
  intro: undefined,
} as const;

const supportedOnboardingTourSteps = {
  ...supportedCustomSteps,
  consents: 'consents',
  profile: 'profile_completion',
} as const;

export type CustomOnboardingTourStepOption = keyof typeof supportedCustomSteps;

export type NonCustomOnboardingTourStepOption = Exclude<OnboardingTourStepOption, CustomOnboardingTourStepOption>;

export type OnboardingTourStepOption = keyof typeof supportedOnboardingTourSteps;

export const isOnboardingTourStepOption = (value?: unknown): value is OnboardingTourStepOption =>
  typeof value === 'string' ? value in supportedOnboardingTourSteps : false;

export const mapToNonCustomOnboardingTourStepOption = (
  step: OnboardingTourStepDataObjectOption,
): NonCustomOnboardingTourStepOption | undefined => {
  for (const [key, value] of Object.entries(supportedOnboardingTourSteps)) {
    if (value === step) {
      // TODO looks like Typescript issue
      // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
      return key as NonCustomOnboardingTourStepOption;
    }
  }

  return undefined;
};

export type OnboardingTourStep = {
  createdAt: Date;
  id: string;
  meta: {
    selectedCalendarOptions?: string[];
  };
  order: number;
  status: 'completed' | 'pending';
  type: OnboardingTourStepDataObjectOption;
  updatedAt: Date;
};

export const createOnboardingTourStep = (step: OnboardingTourStepDataObject): OnboardingTourStep => ({
  createdAt: parseISO(step.created_at),
  id: step.id,
  meta: {
    selectedCalendarOptions: step.meta.selected_calendar_options,
  },
  order: step.order,
  status: step.status,
  type: step.type,
  updatedAt: parseISO(step.updated_at),
});

export type SupportedOnboardingTourStep = {
  data: OnboardingTourStep;
  step: NonCustomOnboardingTourStepOption;
};

export type UpdateOnboardingTourStepOptionHandler = (options: UpdateOnboardingTourStepOptionHandlerOptions) => void;

export type UpdateOnboardingTourStepOptionHandlerOptions = {
  replace?: boolean;
  step: OnboardingTourStepOption;
};
